import React from 'react';
import './NotificationIcon.scss';
import { IoNotifications } from "react-icons/io5";

interface NotificationIconProps {
    count: number;
    onClick: () => void;
}

export const NotificationIcon: React.FC<NotificationIconProps> = ({ count, onClick }) => {
    return <div onClick={onClick} className="notification-icon">
        <IoNotifications size={26} />
        {count > 0 && <span className="notification-icon__count">{count}</span>}
    </div>;
};
